import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {AuthService} from '../auth.service';
import {AppConstants} from '../shared/app.constants';

@Injectable()
export class DashboardService {

  constructor(private http: HttpClient, private auth: AuthService, private appConstants: AppConstants) {
  }

  getDashboardDetails(body): Observable<any> {
    const url = environment.apiBase + `popup/stats?startDate=${body.startDate}&endDate=${body.endDate}&type=${body.type}`;
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(res => res).catch(this.appConstants.errorHandler);
  }
  
}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/dashboard/dashboard.service.ts